import { render } from "./ProducerOffer.vue?vue&type=template&id=12e4b290"
import script from "./ProducerOffer.vue?vue&type=script&lang=js"
export * from "./ProducerOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__